import { AlternativesCTASection, CTASectionProps } from "@components/alternatives/AlternativesCTASection";
import AwardsSection from "@components/new-ui/AwardsSection";
import ClientLogos from "@components/new-ui/ClientLogos";
import { container_classname } from "@components/new-ui/constants";
import CTASection from "@components/new-ui/CTASection";
import FeatureInfoCard, { FeatureInfo } from "@components/new-ui/IndustriesSection/FeatureInfoCard";
import Herosection, { HerosectionProps } from "@components/new-ui/IndustriesSection/Herosection";
import ProductSection, { Product } from "@components/new-ui/IndustriesSection/ProductSection";
import IntegrationSection from "@components/new-ui/IntegrationSection";
import NewLayout from "@components/new-ui/Layout";
import ProblemSectionCard, { ProblemSection } from "@components/solution/problemSectionCard";
import { BlueCardCTASection, GreyCardCTASection } from "@components/solution/solutionCTASection";
import React from "react";

const herosectionData: HerosectionProps = {
    chipTitle: "GALLABOX FOR SMALL  BUSINESSES",
    title: "The WhatsApp business solution every small business needs",
    description: " Automate sales, support, and marketing to conversion, resolve queries, and nurture customers — all while you focus on growth.",
    primaryButtonText: "Start free trial",
    imageUrl: "https://assets.gallabox.com/gb-home/solution/smb/hero-image.png",
    showBookACall: true,
};

const featureInfo1: FeatureInfo = {
    mainTitle: "Shared team inbox",
    subtitle2: "One dashboard, zero chaos.",
    imageUrl: "https://assets.gallabox.com/gb-home/solution/smb/shared-team-inbox.png",
    featureInfoList: [
        "Monitor all customer chats in one dashboard.",
        "Assign conversations, track response times, and ensure accountability.",
        "Never miss a query or duplicate efforts.",
    ],
};

const featureInfo2: FeatureInfo = {
    mainTitle: "AI chatbots and automated flows",
    subtitle2: "Let bots handle busywork, not your team.",
    imageUrl: "https://assets.gallabox.com/gb-home/solution/smb/automated-flow.png",
    featureInfoList: [
        "Resolve FAQs instantly with AI chatbots.",
        "Automate order confirmations, feedback collection, and lead nurturing.",
        "Free your team from repetitive tasks.",
    ],
};
const featureInfo3: FeatureInfo = {
    mainTitle: "Click-to-WhatsApp ads",
    subtitle2: "Turn scrollers into chatters in one tap.",
    imageUrl: "https://assets.gallabox.com/gb-home/solution/smb/click-whatsapp-ads.png",
    featureInfoList: ["Add a “Message us” button to Facebook/Instagram ads.", "Prospects chat directly on WhatsApp — no forms or calls.", "Follow up with personalized offers."],
};
const featureInfo4: FeatureInfo = {
    mainTitle: "Seamless CRM integrations",
    subtitle2: "Your tools, connected — not cluttered.",
    imageUrl: "https://assets.gallabox.com/gb-home/solution/smb/crm-integration.png",
    featureInfoList: ["Sync WhatsApp data with your CRM or Google Sheets.", "Auto-tag leads, send payment reminders, and trigger follow-ups.", "Zero manual entry, zero errors."],
};

const smbProductData: Array<Product> = [
    {
        title: "Enhanced customer engagement",
        description: "Automate order confirmations, FAQs, and feedback collection in real time — saving up to 90% in hiring costs",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/boost-branding.svg",
    },
    {
        title: "Automated responses",
        description: "Leverage smart chatbots to provide immediate resolution,  qualify leads on the spot and drive business outcomes.",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/message-time.svg",
    },
    {
        title: "Centralized communication",
        description: "Send tailored promotions, updates, or reminders to segmented audiences from a single, intuitive dashboard.",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/inbox-unread.svg",
    },
    {
        title: "Cost-effective scalability",
        description: "You can launch WhatsApp campaigns in just a few minutes using Gallabox’s intuitive features.",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/campaign.svg",
    },
    {
        title: "Seamless CRM integration",
        description: "Sync WhatsApp data with your existing CRM and other marketing automation tools for seamless workflows. ",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/integrate.svg",
    },
    {
        title: "Real-time data and analytics",
        description: "Monitor live engagement and conversion metrics, such as open rates, response times, and conversions, to refine strategies.",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/data-analysis.svg",
    },
    {
        title: "Multi-use collaboration",
        description: "Assign roles (sales, support, marketing) with granular permissions, ensuring teams work cohesively.",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/share-circle.svg",
    },
    {
        title: "Built-in compliance guardrails",
        description: "Adhere to WhatsApp’s business policies and data regulations (GDPR, etc.) to avoid penalties and protect customer trust.",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/secure-database.svg",
    },
];

const ProblemSectionData: ProblemSection = {
    maintitle: " Struggling to compete with limited resources?",
    problemSectionCard: [
        {
            imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/group-call.svg",
            title: "Manual follow-ups",
            description: "Manual outreach is time-consuming, slowing down customer response times and reducing conversion rates. ",
        },
        {
            imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/group-chat.svg",
            title: "Fragmented communication",
            description: "Switching between multiple messaging tools and channels can lead to missed opportunities and delayed responses. ",
        },
        {
            imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/campaign.svg",
            title: "Misaligned marketing & sales",
            description: "Traditional channels often fail to engage customers, burdening your marketing efforts and sales teams with unqualified leads.",
        },
        {
            imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/dollar.svg",
            title: "Escalating resource spending",
            description: "As your business grows, maintaining personalized, real-time communication becomes increasingly challenging.",
        },
    ],
};

const blueCardCTAContent: CTASectionProps = {
    content: "Say goodbye to chaos — automate WhatsApp for your SMB with Gallabox",
    imageUrl: "https://assets.gallabox.com/gb-home/solution/sales/sales-cta.png",
    imgAlt: "wa-gallabox",
    btnText: "Get a free trial today",
};

const greyCardCTAContent: CTASectionProps = {
    content: "GoIreland’s success story — Improved transparency and increased conversions",
    imageUrl: "https://assets.gallabox.com/gb-home/solution/smb/goireland.png",
    imgAlt: "wa-gallabox",
    btnText: "Read the story",
};

const sales: React.FC = () => {
    return (
        <NewLayout
            title={"WhatsApp Business Solution for Small Business | Gallabox"}
            description={"Gallabox offers the best WhatsApp business solution for small business—boost sales, marketing, and service with easy automation and smart engagement."}
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/solution/smb/solution-smbs-og.png" }}
            schema={{
                heroOrOgImageAlt: "solutions-small-medium-business-image",
                heroOrOgImageDescription: "The WhatsApp business solution every small business needs",
                heroOrOgImageUrl: "https://assets.gallabox.com/gb-home/solution/smb/hero-image.png",
                softwareFeatureName: "small-medium-business",
            }}
        >
            <Herosection herosection={herosectionData} />
            <section className={`${container_classname} my-10`}>
                <h3 className="text-center text-lg font-normal py-5">Trusted by 10,000+ businesses</h3>
                <ClientLogos />
            </section>

            <ProblemSectionCard problemSection={ProblemSectionData} />

            <section className="mx-5">
                <BlueCardCTASection ctaContent={blueCardCTAContent} />
            </section>
            <h5 className={`${container_classname} md:text-7xl text-5xl mt-20 pr-20`} style={{ fontFamily: "Degular Display" }}>
                Tailor-made for small-to-medium-sized businesses
            </h5>
            <FeatureInfoCard {...featureInfo1} />
            <FeatureInfoCard {...featureInfo2} />
            <FeatureInfoCard {...featureInfo3} />
            <FeatureInfoCard {...featureInfo4} />

            <div className="mx-5">
                <AlternativesCTASection
                    ctaContent={{
                        content: "Grow smarter, not harder.",
                        imageUrl: "https://assets.gallabox.com/gb-home/alternatives/interakt/wa-gallabox.png",
                        imgAlt: "sales-automations",
                        btnText: "Try for free",
                    }}
                />
            </div>

            <ProductSection productCardData={smbProductData} />
            <div className={`${container_classname} my-20`}>
                <h5 className="text-6xl mb-10">Customer story</h5>
            </div>

            <section className="mx-5">
                <GreyCardCTASection ctaContent={greyCardCTAContent} />
            </section>

            <IntegrationSection isLight={true} />
            <AwardsSection />
            <CTASection title="Turn connections into conversions" description="Be among the first to ride the WhatsApp automation wave" />
        </NewLayout>
    );
};

export default sales;
